<template>
    <v-layout justify-center>
        <v-dialog v-model="show" width="310px">
            <v-card>
                <v-toolbar dark color="blue lighten-2" class="titlebar">
                    <v-btn icon dark @click="show = false" x-small>
                        <v-icon small>close</v-icon>
                    </v-btn>
                    <v-toolbar-title><span >Редактирование модуля: </span></v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <module-group-list
                        :module-group-id="moduleGroupId"
                        :module-methods-loaded="true"
                ></module-group-list>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import ModuleGroupList from './ModuleGroupList'
export default {
    name: 'ModuleGroupListDialog',
    props: ['moduleGroupId', 'dialog'],
    components: {
        ModuleGroupList
    },
    created() {
        this.$store.dispatch('modules/loadModuleMethods')
    },
    data() {
        return {
            show: false
        }
    },
    watch: {
        dialog() {
            this.dialog === true ? this.show = true : this.show = false
        },
        show() {
            if (this.show === false) {
                this.$emit('close')
            }
        }
    }
}
</script>

<style scoped>

</style>
